import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    claims: Object,
    releasedIds: Array,
    contactedAt: Object
  }

  connect() {
    document.dispatchEvent(new CustomEvent("admin-marketing:claims-changed", {
      detail: {
        claims: this.claimsValue,
        releasedIds: this.releasedIdsValue,
        contactedAt: this.contactedAtValue
      }
    }))
    this.element.remove()
  }
}
